// ** React Imports
import { useContext } from "react";
import { useParams } from "react-router-dom";

// ** Redux
import { useDispatch, useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import NavItemLink from "components/base/NavItemLink";
import Item from "components/layout/Nav/Item";
import Text from "components/typography/Text";

// ** Utils
import pseudoFormat from "utils/pseudoFormat";

// ** Contexts
import deviceTypeContext from "contexts/deviceTypeContext";
import { getUserProfileFriends } from "store/modules/user-profile/actions/get-user-profile-friends.action";
import { ANY } from "helpers/constants";

// #####################################################

export const UserNavSectionFriendsItem = () => {
	const { login } = useParams();

	const dispatch = useDispatch();

	const isAuth = useSelector((state) => state.globalCommon.isAuth);
	const friendsCount = useSelector(
		(state) => state.userProfileMain.statistics.userFriends,
	);

	const { isPhone } = useContext(deviceTypeContext);

	const { t } = useTranslation();

	// #####################################################

	return (
		<NavItemLink
			container={Item}
			to={`/users/${login.toLowerCase()}/friends`}
			key={`userFriends`}
			exact={false}
			onClick={() => {
				dispatch(
					getUserProfileFriends({
						login,
						isAuth,
						page: 1,
						sex: ANY,
						infinityScroll: false,
					}),
				);
			}}
		>
			<Item.Content
				noPad
				flex
				style={{
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				{isPhone ? (
					<Block flex column alignCenter>
						<Text>{t(`userProfile:userFriends`)}</Text>
						{friendsCount && (
							<Text bold>{pseudoFormat(friendsCount)}</Text>
						)}
					</Block>
				) : (
					<>
						{/* Using {t(`userProfile:userGallery`)} without a Text wrapper caused a removeChild error during translation and resize */}
						<Text>{t(`userProfile:userFriends`)}</Text>
						{friendsCount ? (
							<Text bold ml={1}>
								{pseudoFormat(friendsCount)}
							</Text>
						) : null}
					</>
				)}
			</Item.Content>
		</NavItemLink>
	);
};

// #####################################################
